export const isHandoffActive = state => state.register.payment.handoff;
